import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

const ALL = "__all";

export function Sel({ value, onChange, options, placeholder, testid, className }) {
  return (
    <Select value={value === "" ? ALL : value} onValueChange={(v) => onChange(v === ALL ? "" : v)}>
      <SelectTrigger className={cn("h-10 rounded-xl bg-card min-w-[140px]", className)} data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent className="bg-card border-border rounded-xl max-h-72">
        {options.map(([v, l]) => (
          <SelectItem key={v || ALL} value={v === "" ? ALL : v} data-testid={`${testid}-option-${(v || "all").toString().toLowerCase()}`}>{l}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export function Table({ head, children, testid }) {
  return (
    <div className="uc-card overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border text-left">
            {head.map((h) => <th key={h} className="eyebrow px-4 py-3 whitespace-nowrap font-semibold">{h}</th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-border/70">{children}</tbody>
      </table>
    </div>
  );
}

export const td = "px-4 py-3 whitespace-nowrap";
